// What makes the Terms of sale (and the DPA they include) binding: the mention above every button that creates an
// account, and the box of the checkout. The acceptance date is the account's or the order's `created_at`; the
// versions are those of sculpt-api `content/` (sculpt-api review DEC-05). Each link opens in a new tab.
import { Trans, useTranslation } from 'react-i18next';
import { LEGAL_URLS } from '../config';

function legalLink(href: string) {
  return <a href={href} target="_blank" rel="noreferrer" className="text-accent underline hover:text-accent-dark" />;
}

const LINKS = { terms: legalLink(LEGAL_URLS.terms), dpa: legalLink(LEGAL_URLS.dpa), privacy: legalLink(LEGAL_URLS.privacy) };

/** "By continuing, you accept the Terms of sale, including the Data Processing Agreement. See our Privacy policy." */
export function LegalMention() {
  const { t } = useTranslation();
  return (
    <p className="text-[12.5px] leading-[1.5] text-ink" data-testid="legal-mention">
      <Trans t={t} i18nKey="legal.mention" components={LINKS} />
    </p>
  );
}

/** The checkout box's label: "I accept the Terms of sale, including the Data Processing Agreement." */
export function AcceptTerms() {
  const { t } = useTranslation();
  return <Trans t={t} i18nKey="legal.accept" components={{ terms: LINKS.terms, dpa: LINKS.dpa }} />;
}
